'use strict';

var $ = require('jquery');
var PubSub = require('tscom-pubsub');

var ModalView = require('standard-vote/app/scripts/views/modal');

module.exports = ModalView.extend({
    initialize: function() {
        $('.modal').click(this.onModalClick.bind(this));
    },
    close: function() {
        PubSub.trigger('modal:close');
    },
    onModalClick: function(e) {
        if (e.target.className == 'modal in') {
            PubSub.trigger('modal:close');
        }
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/modal.js